import React from 'react'

const TrainerTile = () => {
    return (
        <div>
            <svg width="40" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.6814 3.86992C9.6814 6.00721 7.94878 7.73983 5.81149 7.73983C3.67419 7.73983 1.94157 6.00721 1.94157 3.86992C1.94157 1.73262 3.67419 0 5.81149 0C7.94878 0 9.6814 1.73262 9.6814 3.86992Z" fill="#475969" />
                <path d="M0.00694061 39.6667V15.4797C0.00694061 13.5447 -0.221439 9.67484 1.9419 9.67482L22.2586 9.67479L22.259 13.5447H11.6167V39.6667H7.74677V27.0894H3.87686V39.6667H0.00694061Z" fill="#475969" />
                <path d="M34.8359 1.93496H13.5513V5.80488H30.9659V23.2195H15.4863V27.0894H21.2912L25.1611 38.6992H29.031L25.1611 27.0894H34.8359V1.93496Z" fill="#475969" />
            </svg>

        </div>
    )
}

export default TrainerTile
